module.exports = __webpack_public_path__ + "img/hero.23e36a76.jpg";